import {Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {GeneralRoutesConfig} from '../configs/general-routes.config';
import {AuthService} from './auth.service';
import * as UIModels from '@shared-models/index';


@Injectable()
export class AppInitService {
    routesConfig = GeneralRoutesConfig;

    constructor(
        private injector: Injector,
        private httpClient: HttpClient,
        private authService: AuthService,
        private router: Router
    ) {
    }

    getSettings(rootUrl: string): Promise<any> {
        
        if ((!this.authService.accessToken || this.authService.isTokenExpired) && window.location.pathname !== rootUrl) {
            const url = window.location.pathname + window.location.search;
            localStorage.setItem("UrlToBeRedirected", url);
            if (url === '/prehire/index.html') {
                localStorage.setItem(UIModels.CE.StorageKeys.redirectPathname, url);
            }
            window.location.assign('/');
            
            return;
        } else {
            return new Promise((resolve, reject) => {
                if (!this.authService) {
                    // tslint:disable-next-line:max-line-length
                    (window as any).location = '/error.html?errorText=' + encodeURIComponent('Authentication service cannot be initialized.');
                    resolve(false);
                }

                this.authService
                    .authorizeUser()
                    .then((isTokenAcquired) => {
                        if (!isTokenAcquired) {
                            this.authService.login();
                            resolve(false);
                            return;
                        } else {
                            const savedPathname = localStorage.getItem(UIModels.CE.StorageKeys.redirectPathname);
                            const UrlToBeRedirected = localStorage.getItem("UrlToBeRedirected");

                            if (savedPathname && savedPathname === '/prehire/index.html') {
                                localStorage.removeItem(UIModels.CE.StorageKeys.redirectPathname);
                                window.location.assign(`https://${window.location.host}${savedPathname}`);
                            }
                            else if (UrlToBeRedirected !== undefined && UrlToBeRedirected !== null){
                                localStorage.removeItem("UrlToBeRedirected");
                                this.router.navigateByUrl(UrlToBeRedirected);
                            }
                            else {
                             //Keeping the window.location url as it is.   
                            }
                            resolve(true);
                        }
                    }).catch(err => {
                    resolve(true);
                });
            });
        }


    }
}
